import "core-js/modules/es.symbol.description.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from 'react';
import axios from 'axios';
import { Spinner } from '@digitools/honest-react';
export var PortalStatusContext = /*#__PURE__*/createContext({
  maintenanceModeEnabled: false,
  maintenanceModeBackdoorAccessEnabled: false,
  isStatusLoading: false
});
var getPortalStatus = function () {
  return axios.get('/portal-status');
};
var PortalStatusProvider = function (_a) {
  var children = _a.children;
  var _b = useState(false),
    maintenanceModeEnabled = _b[0],
    setMaintenanceModeEnabled = _b[1];
  var _c = useState(false),
    maintenanceModeBackdoorAccessEnabled = _c[0],
    setMaintenanceModeBackdoorAccessEnabled = _c[1];
  var _d = useState(false),
    isStatusLoading = _d[0],
    setIsStatusLoading = _d[1];
  var resolvePortalStatus = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var _a, maintenanceMode, maintenanceModeBackdoorAccess, _1;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            setIsStatusLoading(true);
            _b.label = 1;
          case 1:
            _b.trys.push([1, 3, 4, 5]);
            return [4 /*yield*/, getPortalStatus()];
          case 2:
            _a = _b.sent().data, maintenanceMode = _a.maintenanceMode, maintenanceModeBackdoorAccess = _a.maintenanceModeBackdoorAccess;
            setMaintenanceModeEnabled(maintenanceMode);
            setMaintenanceModeBackdoorAccessEnabled(maintenanceModeBackdoorAccess);
            return [3 /*break*/, 5];
          case 3:
            _1 = _b.sent();
            return [3 /*break*/, 5];
          case 4:
            setIsStatusLoading(false);
            return [7 /*endfinally*/];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  };
  useState(function () {
    resolvePortalStatus();
  });
  var value = {
    maintenanceModeEnabled: maintenanceModeEnabled,
    maintenanceModeBackdoorAccessEnabled: maintenanceModeBackdoorAccessEnabled,
    isStatusLoading: isStatusLoading
  };
  return _jsx(PortalStatusContext.Provider, __assign({
    value: value
  }, {
    children: isStatusLoading ? _jsx("div", __assign({
      style: {
        textAlign: 'center'
      }
    }, {
      children: _jsx(Spinner, {
        isShown: true
      })
    })) : children
  }));
};
export default PortalStatusProvider;